import Vue from 'vue';
import Component from 'vue-class-component';
import { Emit, Prop } from 'vue-property-decorator';

@Component({
  name: 'ed-collaborative-text-editor',
  components: {
    EdTableModal: () => import('@/components/common/ed-collaborative-text-editor/ed-table-modal.vue'),
  }
})
export default class EdCollaborativeTextEditor extends Vue {

  @Prop({default:'editor'}) readonly editorId: string;
  @Prop({}) readonly quillEditor: any;
  @Prop() readonly bgImage: string;
  @Prop({default: false}) readonly bgClass: string;
  @Prop() readonly minHeight: string;
  @Prop({default:false}) readonly pageStyle: boolean;
  

  get cssVars() {
    return {
      '--bg-image': this.bgImage ? `url(${this.bgImage})` : '',
      'min-height' : this.minHeightEditor ?? null,
    }
  }

  get minHeightEditor() {
    return (this.minHeight) ? `${this.minHeight}px` : null;
  }

  mounted() {
    this.loadEditorFinished();
  }

  @Emit('loadEditorFinished')
  private loadEditorFinished() {
    return true;
  }
}
